// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Lx5A8","col":"styles_col__Xe0hh","fulfillmentStatus":"styles_fulfillmentStatus___21Iq","emailCol":"styles_emailCol__PisM4"};